<template>

    <div>
        <v-row
            justify="center"
        >
            <v-dialog
                v-model="dialog"
                max-width="100%"
                persistent
            >
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form
                                ref="form"
                                lazy-validation>
                                <v-row>
                                    <v-col cols="12" sm="12" md="6">
                                        <span>Annual Visit?</span>
                                        <v-row class="ml-0">
                                            <v-switch
                                                label="Yes"
                                                value="Yes"
                                                v-model="item.annualVisit"
                                                :rules="requiredField"
                                            ></v-switch>
                                            <v-switch
                                                label="No"
                                                value="No"
                                                v-model="item.annualVisit"
                                                :rules="requiredField"
                                            ></v-switch>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-datetime-picker
                                            v-model="item.date"
                                            label="Date and Time of Visit"
                                            prepend-icon="mdi-calendar"
                                            :rules="requiredField"
                                        >
                                        </v-datetime-picker>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-select
                                            v-model="item.visitType"
                                            label="Visit Type"
                                            :items="sortedVisitType"
                                            item-value="Name"
                                            item-text="Name"
                                            :rules="requiredField"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-select
                                            return-object
                                            label="Reviewing Provider"
                                            v-model="item.reviewingProvider"
                                            :items="providers"
                                            item-value="Provider._id"
                                            item-text="Provider.Name"
                                            v-on:change="changeProvider"
                                            :rules="requiredField"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field
                                            readonly
                                            v-model="item.providerType"
                                            label="Provider Type"
                                            :rules="requiredField"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            label="Facility Name"
                                            v-model="item.facility"
                                            :rules="requiredField"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            label="Facility Address"
                                            v-model="item.address"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field label="City" v-model="item.city"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field label="State" v-model="item.state"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field label="Zip" v-model="item.zip"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            label="Phone Number"
                                            v-model="item.phone"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea
                                            label="Reason for Visit"
                                            v-model="item.reason"
                                            outlined
                                        ></v-textarea>
                                    </v-col>

                                    <v-col cols="12">
                                        <span>Were there any medication changes?</span>
                                        <v-switch
                                            label="Yes"
                                            value="Yes"
                                            v-model="item.medChange"
                                            :rules="requiredField"
                                        ></v-switch>
                                        <v-switch
                                            label="No"
                                            value="No"
                                            v-model="item.medChange"
                                            :rules="requiredField"
                                        ></v-switch>
                                        <!-- <v-switch label="Yes" v-model="item.medChange"></v-switch> -->
                                    </v-col>

                                    <v-col cols="12" v-if="item.medChange === 'Yes'">
                                        <v-textarea
                                            label="What medication(s) was changed?"
                                            outlined
                                            :rules="requiredField"
                                            v-model="item.medChangeDescription"
                                        ></v-textarea>
                                    </v-col>

                                    <v-col cols="12">
                                        <div class="blue darken-4 white--text pa-4">
                                            THIS SECTION SHOULD BE FILLED OUT BY THE STAFF
                                        </div>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-file-input
                                            class="pa-2"
                                            label="Document Upload"
                                            v-model="newDocuments"
                                            name="newDocument"
                                            :placeholder="item.document"
                                            filled
                                            multiple
                                            prepend-icon="mdi-camera"
                                            accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                            @change="fileSelected"
                                        >
                                            <template #selection="{ text, index }">
                                                <v-chip small label close color="primary"
                                                        @click:close="deleteChip(index)">{{ text }}
                                                </v-chip>
                                            </template>
                                        </v-file-input>
                                        <v-expansion-panels
                                            v-model="panel"
                                            multiple
                                        >
                                            <v-expansion-panel>
                                                <v-expansion-panel-header disable-icon-rotate
                                                                          class="text-uppercase font-weight-bold font-italic info">
                                                    Document List
                                                    <template v-slot:actions>
                                                        <v-icon>
                                                            mdi-view-list
                                                        </v-icon>
                                                    </template>
                                                </v-expansion-panel-header>

                                                <v-expansion-panel-content>
                                                    <template>
                                                        <v-card
                                                            class="mx-auto"
                                                            tile
                                                        >
                                                            <v-list dense>
                                                                <v-list-item-group
                                                                    color="primary"
                                                                >
                                                                    <v-list-item
                                                                        v-for="(item, i) in uploadedDocuments"
                                                                        :key="i"
                                                                    >
                                                                        <v-list-item-icon>
                                                                            <v-icon color="error"
                                                                                    @click="removeDocument(item.id)">
                                                                                mdi-close-circle
                                                                            </v-icon>
                                                                        </v-list-item-icon>
                                                                        <v-list-item-content>
                                                                            <v-chip
                                                                                class=""
                                                                                color="primary"
                                                                                text-color=""
                                                                                label
                                                                            >
                                                                                {{ item.name }}
                                                                            </v-chip>
                                                                            <div v-if="item.ext !='pdf' ">
                                                                                <v-img
                                                                                    max-height="280"
                                                                                    max-width="350"
                                                                                    :src="item.aws"
                                                                                ></v-img>
                                                                            </div>
                                                                            <div v-if="item.ext =='pdf' ">
                                                                                <LoadPDF
                                                                                    :pdfFile="item.aws"
                                                                                    :pdfName="item.name"
                                                                                />
                                                                            </div>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                </v-list-item-group>
                                                            </v-list>
                                                        </v-card>
                                                    </template>

                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-file-input
                                            class="pa-2"
                                            label="Additional Documents Upload"
                                            v-model="newAdditionalDocuments"
                                            name="newAdditionalDocument"
                                            filled
                                            multiple
                                            prepend-icon="mdi-camera"
                                            accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                            @change="fileSelected2"
                                        >
                                            <template #selection="{ text, index }">
                                                <v-chip small label close color="primary"
                                                        @click:close="deleteAdditionalChip(index)">{{ text }}
                                                </v-chip>
                                            </template>
                                        </v-file-input>
                                        <v-col cols="12" sm="12" md="3"
                                               v-for="item in newAdditionalDocuments"
                                               :key="item.aws"
                                        >
                                        </v-col>
                                        <v-expansion-panels
                                            v-model="panel2"
                                            multiple
                                        >
                                            <v-expansion-panel>
                                                <v-expansion-panel-header disable-icon-rotate
                                                                          class="text-uppercase font-weight-bold font-italic info">
                                                    Additional Documents List
                                                    <template v-slot:actions>
                                                        <v-icon>
                                                            mdi-view-list
                                                        </v-icon>
                                                    </template>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <template>
                                                        <v-card
                                                            class="mx-auto"
                                                            tile
                                                        >
                                                            <v-list dense>
                                                                <v-list-item-group
                                                                    color="primary"
                                                                >
                                                                    <v-list-item
                                                                        v-for="(item, i) in uploadedAdditionalDocuments"
                                                                        :key="i"
                                                                    >
                                                                        <v-list-item-icon>
                                                                            <v-icon color="error"
                                                                                    @click="removeDocument(item.id)">
                                                                                mdi-close-circle
                                                                            </v-icon>
                                                                        </v-list-item-icon>
                                                                        <v-list-item-content>
                                                                            <v-chip
                                                                                class=""
                                                                                color="primary"
                                                                                text-color=""
                                                                                label
                                                                            >
                                                                                {{ item.name }}
                                                                            </v-chip>
                                                                            <div v-if="item.ext !='pdf' ">
                                                                                <v-img
                                                                                    max-height="280"
                                                                                    max-width="350"
                                                                                    :src="item.aws"
                                                                                ></v-img>
                                                                            </div>
                                                                            <div v-if="item.ext =='pdf' ">
                                                                                <LoadPDF
                                                                                    :pdfFile="item.aws"
                                                                                    :pdfName="item.name"
                                                                                />
                                                                            </div>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                </v-list-item-group>
                                                            </v-list>
                                                        </v-card>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field
                                            label="Current Weight"
                                            v-model="item.weight"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field
                                            label="Current Blood Pressure"
                                            v-model="item.bloodPressure"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field
                                            label="A1C"
                                            v-model="item.a1c"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-textarea
                                            label="Comments on Visit"
                                            outlined
                                            v-model="item.comments"
                                            :rules="requiredField"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-checkbox
                                            label="Follow Up Appointment Needed"
                                            v-model="item.followUp"
                                            @click="showEventDialog(item.followUp)"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-row class="ma-0">
                                        <v-col cols="12" sm="12" md="6">
                                            <v-datetime-picker
                                                v-model="item.followUpDate"
                                                label="Date and Time of Follow up Visit"
                                                prepend-icon="mdi-calendar"
                                                v-if="item.followUp"
                                            >
                                            </v-datetime-picker>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6" v-if="item.followUp">
                                            <v-datetime-picker
                                                v-model="item.followUpDate"
                                                label="Date and Time of Visit"
                                                prepend-icon="mdi-calendar"
                                            >
                                            </v-datetime-picker>
                                        </v-col>
                                    </v-row>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-checkbox
                                            label="Signature"
                                            @click="addSignature()"
                                            v-model="signed"
                                        ></v-checkbox>
                                        <v-text-field
                                            v-model="item.signature"
                                            readonly
                                            :rules="requiredField"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- <v-btn
                          class="white--text"
                          color="#259647"
                          @click="addVisit()"
                          v-if="newVisit"
                          >Save</v-btn
                        >
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="updateVisit()"
                          v-if="newItem"
                          >Update</v-btn
                        >
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn> -->
                        <v-btn
                            fab
                            small
                            @click="showPrintModal(item)"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="!newItem"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn
                            :color="newItem ? 'success' : 'primary'"
                            @click="newItem ? onAddItem() : onUpdateItem()"
                        >
                            {{ newItem ? "Save" : "Update" }}
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="close">
                            Cancel
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <add-events-dialog
                :newEvent="newEvent"
                @on-add-event="(item) => onAddEvent(item)"
                @onShowEventDialog="(item) => showEventDialog(item)"
            />
        </v-row>
    </div>

</template>

<script>
/*eslint-disable */
import axios from "axios";
import moment from "moment";
import { mapState, mapActions, mapGetters } from "vuex";

import LoadPDF from '../../../components/LoadPDF.vue';
import AddEventsDialog from '../../../components/events/EventForm.vue';
import renameFileHelper from '../../../mixins/renameFileHelper';
import Swal from 'sweetalert2';
import DateTimeUtil from '../../../../utils/date-time.util';
import ClientService from "@/service/client.service";


const url = require("../../../client_config/config").url;

export default {
    mixins: [renameFileHelper],
    components: {LoadPDF, AddEventsDialog},
    props: {
        newItem: {
            type: Boolean,
            default: true,
        },
        staffName: {
            type: String,
            default: "",
        },
        clientName: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            items: [
                {text: 'Real-Time', icon: 'mdi-close-circle'},
                {text: 'Audience', icon: 'mdi-account'},
                {text: 'Conversions', icon: 'mdi-flag'},
            ],
            isDownloadPDF: false,
            isAdditionalPDF: false,
            isDownloadIMAGE: false,
            isAdditionalIMAGE: false,
            item: {
                annualVisit: "",
                visitType: "",
                reviewingProvider: "",
                providerType: "",
                reason: "",
                medChange: false,
                medChangeDescription: "",
                facility: "",
                address: "",
                city: "",
                state: "",
                zip: "",
                phone: "",
                date: "",
                document: "",
                additionalDocument: "",
                weight: "",
                bloodPressure: "",
                a1c: "",
                comments: "",
                followUp: "",
                followUpDate: "",
                signature: localStorage.getItem("Name") + " - " + new Date(),
                eventID: "",
            },

            defaultItem: {
                annualVisit: "",
                visitType: "",
                reviewingProvider: "",
                providerType: "",
                reason: "",
                medChange: false,
                medChangeDescription: "",
                facility: "",
                address: "",
                city: "",
                state: "",
                zip: "",
                phone: "",
                date: "",
                document: "",
                additionalDocument: "",
                weight: "",
                bloodPressure: "",
                a1c: "",
                comments: "",
                followUp: "",
                followUpDate: "",
                signature: localStorage.getItem("Name") + " - " + new Date(),
                eventID: "",
            },
            visitType: [
                "Admitting Physician",
                "Allergist",
                "Appointed Attorney",
                "Attending Physician",
                "Appointed Attorney",
                "Audiologist",
                "Behaviorist",
                "Cardiologist",
                "Care Worker Supervisor",
                "Case Worker",
                "Chiropractor",
                "Counselor/Therapist",
                "Dentist",
                "Dermatologist",
                "Ears, Nose and Throat (ENT)",
                "Emergency Room",
                "Employer",
                "Endocrinologist",
                "Gastroenterologist",
                "Gynecologist",
                "Hospital",
                "Lab",
                "Legal Guardian",
                "Nephrologist",
                "Neurologist",
                "Nurse",
                "Nurse Practitioner",
                "Nutritionist/Dietician",
                "Occupational Therapist",
                "Optometrist/Ophthalmologist",
                "Orthopedic",
                "Parent (Connect Access)",
                "Pharmacy",
                "Phlebotomist",
                "Physical Therapist",
                "Physician or Specialist",
                "Physician Assistant",
                "Podiatrist",
                "Primary Care MD",
                "Psychiatrist",
                "Public Guardian",
                "Radiologist",
                "Sleep Specialist",
                "Support Coordinator",
                "Surgeon",
                "Urologist",
                "Urgent Care",
                "Work Site",
                "Wound Care"
            ],
            newVisit: false,
            signed: true,
            visitID: "",
            uploadFile: "",
            uploadFile2: "",
            newDocuments: [],
            uploadedDocuments: [],
            newAdditionalDocuments: [],
            documentPDF: [],
            isDocumentPDF: false,
            uploadedAdditionalDocuments: [],
            documentAdditionalPDF: [],
            requiredField: [
                v => !!v || 'This is required',
            ],
            panel: [0, 1],
            panel2: [0, 1],
            newEvent: true,
            fileCounter: 1,
            providers: []
        };
    },

    created() {
        this.getProviders()
    },

    computed: {
        ...mapState({
            staff: (state) => state.users.user.Name,
        }),

        dialog: {
            get() {
                return this.$store.state.medicalVisit.dialog;
            },
            set(val) {
                this.$store.commit("medicalVisit/SET_DIALOG", val);
            },
        },

        sortedVisitType() {
            return this.visitType.slice().sort();
        },


        titleForm() {
            return this.newItem ? "New Med Visit" : "Update Med Visit"
        }

    },


    methods: {
        ...mapActions({
            getClientProviders: "clientProviders/getItem",
        }),

        async getProviders() {
            let response = await this.getClientProviders(this.$route.params.clientID);
            this.providers = response.data;
        },

        validate() {
            return this.$refs.form.validate();
        },
        validateReset() {
            if (this.$refs.form !== undefined) {
                this.$refs.form.reset();
            }
        },

        async onViewItem(item) {
            const {data} = item;
            let convertedDataKey = this.convertKey(data);

            this.item = {
                ...convertedDataKey,
                date: DateTimeUtil.toJSDate(data.Date),
                followUpDate: data?.FollowUpDate && DateTimeUtil.toJSDate(data.FollowUpDate),
                reviewingProvider: this.providers.find(provider => provider.Provider._id === data.ReviewingProvider._id) || '',
            };

            this.uploadedDocuments = [];
            this.uploadedAdditionalDocuments = [];

            //cause some document undefined so need to add "optional chaining operator"
            if (data?.documents?.length > 0) {
                const uploadedDocuments = [];
                const uploadedAdditionalDocuments = [];

                for (let i = 0; i < data.documents.length; i++) {
                    if (data.documents[i].Category == "Medical Visit") {
                        let fileExt = data.documents[i].AWSLink.split('.').pop();
                        uploadedDocuments.push({
                            name: data.documents[i].Name,
                            id: data.documents[i]._id,
                            aws: data.documents[i].AWSLink,
                            ext: fileExt,
                        });
                    } else if (data.documents[i].Category == "Medical Visit Additional") {
                        let fileExt = data.documents[i].AWSLink.split('.').pop();
                        uploadedAdditionalDocuments.push({
                            name: data.documents[i].Name,
                            id: data.documents[i]._id,
                            aws: data.documents[i].AWSLink,
                            ext: fileExt,
                        });
                    }
                }

                this.uploadedDocuments = uploadedDocuments;
                this.uploadedAdditionalDocuments = uploadedAdditionalDocuments;
            }

            this.visitID = data._id;
            this.changeProvider();
        },

        onAddItem() {

            if (!this.item.date) {
                alert('Please fill up date and time of visit.');
                return;
            }

            if (this.validate()) {

                this.item.Staff = this.staff; // user for created by in Calendar
                const {item} = this;

                let fileUpload = {
                    uploadFile: this.uploadFile,
                    uploadFile2: this.uploadFile2,
                };

                let followupData = item.followUpDate != "" ? this.addFollowUpVisit() : "";

                this.$emit(
                    "on-add-item",
                    {...item, reviewingProvider: item.reviewingProvider._id}, //temporary removed eventID
                    fileUpload,
                    followupData
                );

            } else {
                this.$emit("required-field")
            }

        },

        addFollowUpVisit() {
            const {item} = this;
            return {
                ...item,
                date: item.followUpDate,
                reviewingProvider: item.reviewingProvider._id,
            };
        },
        onUpdateItem() {
            if (this.validate()) {
                let fileUpload = {
                    uploadFile: this.uploadFile,
                    uploadFile2: this.uploadFile2,
                };

                this.$emit("on-update-item", this.item, fileUpload, this.visitID);
            } else {
                this.$emit("required-field")
            }

        },

        showPrintModal(item) {
            const id = item._id;
            const downloadUrl = `${url}/medicalVisits/download?id=${id}`;

            // Show the "Print in progress" modal
            Swal.fire({
                title: 'Print in Progress',
                text: 'Please wait while the PDF is being generated and processed...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            // Make a request to the backend API to generate the PDF
            fetch(downloadUrl)
                .then((response) => response.blob())
                .then((blob) => {
                    const blobUrl = URL.createObjectURL(blob);
                    const printWindow = window.open(blobUrl);

                    printWindow.onload = function () {
                        // Close the modal when the printing process is complete
                        Swal.close();

                        printWindow.print();

                        URL.revokeObjectURL(blobUrl);
                    };
                })
                .catch((error) => {
                    console.error('Error generating or printing the PDF:', error);
                    Swal.fire('Error', 'Failed to generate or print the PDF', 'error');
                });
        },


        addSignature() {
            const {item} = this;
            if (item.signature === "") {
                item.signature = this.staff + " - " + new Date();
                this.signed = true;
            } else {
                this.signed = false;
                item.signature = "";
            }
        },
        changeProvider() {
            const {item} = this;

            item.providerType = item.reviewingProvider.Provider.Profession;
            item.facility = item.reviewingProvider.Provider.Company;
            item.address = item.reviewingProvider.Provider.Address;
            item.city = item.reviewingProvider.Provider.City;
            item.state = item.reviewingProvider.Provider.State;
            item.zip = item.reviewingProvider.Provider.Zip;
            item.phone = item.reviewingProvider.Provider.Phone;
        },

        convertKey(data) {
            const output = Object.entries(data).map(([key, value]) => [
                key[0].toLowerCase() + key.slice(1),
                value,
            ]);

            return Object.fromEntries(output);
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.item = Object.assign({}, this.defaultItem);
            });
            this.uploadedDocuments = [];
            this.uploadedAdditionalDocuments = [];
            this.newDocuments = [];
            this.newAdditionalDocuments = [];
            this.fileCounter = 1
        },

        async fileSelected(e) {
            this.uploadFile = await this.renameFileHelper(e, this.clientName, "MedVisit");
        },

        async fileSelected2(e) {
            this.uploadFile2 = await this.renameFileHelper(e, this.clientName, "MedVisit");
        },

        deleteChip(index) {
            this.newDocuments.splice(index, 1)
        },

        deleteAdditionalChip(index) {
            this.newAdditionalDocuments.splice(index, 1)
        },

        removeDocument(id) {
            confirm("Are you sure you want to delete this item?") &&
            this.deleteDocument(id);
        },

        deleteDocument(id) {
            axios.delete(`${url}/documents/${id}`)
                .then((response) => {
                    if (response.status == 400) {
                        response.json().then(function (data) {
                            return data.msg;
                        });
                    }
                    if (response.status == 204) {
                        this.removeFromList(id);
                        alert("Deleted Successfully");
                    }

                });
        },

        removeFromList(id) {
            let checkUploadedDocument = this.uploadedDocuments.map(function (x) {
                return x.id
            }).indexOf(id);
            if (checkUploadedDocument) {
                this.uploadedDocuments.forEach((element, index) => {
                    if (element.id == id) {
                        this.uploadedDocuments.splice(index, 1);
                    }
                });
            }

            let checkUploadedAdditionalDocument = this.uploadedAdditionalDocuments.map(function (x) {
                return x.id
            }).indexOf(id);
            if (checkUploadedAdditionalDocument) {
                this.uploadedAdditionalDocuments.forEach((element, index) => {
                    if (element.id == id) {
                        this.uploadedAdditionalDocuments.splice(index, 1);
                    }
                });
            }

        },
        /*
        renameFile(files) {
          // let date = new Date()
          // let datestring = `${(date.getMonth()+1)}${date.getDate()}${date.getFullYear()}`

          let dateString = moment(new Date()).format('MMDDYYYY')

          let renamedFiles = []
          for (let i = 0; i < files.length; i++) {
            let file = files[i];
            let ext = file.name.split(".").pop();
            let splitName = this.clientName.split(" ")
            let counter = `${0}${this.fileCounter++}`

            if(this.fileCounter >= 10){
              counter = this.fileCounter
            }

            let fileName =
              `${splitName[0].toLowerCase()}${splitName[1]}-${dateString}-${'medVisit'}-${counter}`

            renamedFiles.push(
              new File([file], `${fileName}.${ext}`, {
                type: file.type,
              })
            );
          }
          return renamedFiles
        },
        */

        showEventDialog(e) {
            this.newEvent = true;
            this.$store.commit("events/SET_DIALOG", e);
            this.item.followUp = e;
        },

        onAddEvent(data) {
            if (data.Status) {
                this.item.EventID = data.EventID;
            }
        },

    },
};
</script>
